import React, { useCallback } from 'react';
import Countdown from 'react-countdown';

function Question({ question, number, handleCorrect, handleIncorrect }) {
  const choices = [];
  let choicesClass = '';
  question.choices.forEach((val, index) => {
    let txtClass = '';
    if (val.length > 9) {
      choicesClass = 'txt-left';
    }
    if (val.length > 16) {
      txtClass = 'length-lg length-17';
    } else if (val.length > 15) {
      txtClass = 'length-lg length-16';
    } else if (val.length > 14) {
      txtClass = 'length-lg length-15';
    } else if (val.length > 13) {
      txtClass = 'length-lg length-14';
    } else if (val.length > 12) {
      txtClass = 'length-lg length-13';
    } else if (val.length > 11) {
      txtClass = 'length-lg length-12';
    } else if (val.length > 10) {
      txtClass = 'length-lg length-11';
    } else if (val.length > 9) {
      txtClass = 'length-lg length-10';
    }
    choices.push(
      <button
        onTouchStart={() => {}}
        key={index}
        index={index}
        className="questionChoiceBtn"
        onClick={() => {
          if (question.correct == index) {
            handleCorrect();
          } else {
            handleIncorrect();
          }
        }}
      >
        <div className="questionChoiceBtnInner">
          <span className="number">
            <img src={'assets/img/number-choice-' + Number(index + 1) + '.png'} alt={Number(index + 1)} className="offBtn" />
            <img src={'assets/img/number-choice-' + Number(index + 1) + '-on.png'} alt={Number(index + 1)} className="onBtn" />
          </span>
          <span className={txtClass + ' txt'}>
            <span className="txtInner" dangerouslySetInnerHTML={{ __html: val }} />
          </span>
        </div>
      </button>
    );
  });

  let ttlClass = '';
  if (question.title.length > 42) {
    ttlClass = 'length-lg length-42';
  } else if (question.title.length > 20) {
    ttlClass = 'length-lg length-20';
  }

  return (
    <div className={'questionContent' + question.number + ' questionContent'}>
      <div className="questionTitle">
        <div className="questionNumber">
          <img src={'assets/img/number-title-' + Number(number + 1) + '.png'} alt={Number(number + 1)} />
        </div>
        <div className={ttlClass + ' questionTitleInner'}>
          <div className="titleInnerWrap">
            <div className="titleInner" dangerouslySetInnerHTML={{ __html: question.title }} />
          </div>
        </div>
      </div>
      <div className={choicesClass + ' questionChoiceBtns'}>{choices}</div>
      <div className="questionCountdown">
        <div className="top">
          <Countdown
            date={Date.now() + 30000}
            // date={Date.now() + 300000}
            renderer={({ seconds }) => {
              return <span>{seconds}</span>;
            }}
            onComplete={handleIncorrect}
            //
          />
          <div className="min">秒</div>
        </div>
        <div className="bottom">のこり時間</div>
      </div>
    </div>
  );
}

export default Question;
